/* eslint-disable max-len */
export default {
  header: {
    navigation: {
      home: 'Home',
      downloads: '下载 ',
      twitter: 'Twitter',
      wallet: 'Wallet',
      explorer: '浏览器',
      ecosystem: '生态系统',
      skyminer: '天空矿机',
      hardware: 'Hardware',
      blog: '博客',
      telegram: 'Telegram',
      discord: 'Discord',
      getWallet: '购买天空链',
      jobs: '工作',
      ecosystem_overview: '概述',
      skywire: 'Skywire',
      skywallet: 'Skywallet',
      obelisk: 'Obelisk',
      fiber: 'Fiber',
      cx: 'CX',
      cxo: 'CXO',
      other: 'Other',
      pressreleases: 'Press Releases',
      gallery: '展示廊',
      events: 'Events',
      explorerApi: 'Explorer API',
      hardwareStore: '硬件商店',
      merchandise: '商店',
      skywallethdk: 'Skywallet HDK',
      whitepaper: 'Whitepapers',
    },
  },
  notFound: {
    404: '404',
    message: '哎！看来你迷失了，这个页面不存在或者已经转到新的URL',
    title: '没法找到页面',
    heading: '没法找到页面',
    home: '主页',
  },
  getStarted: {
    heading: '加入Skycoin',
    paragraph: 'True decentralization means no government can censor Skywire, no corporate interest can stop it.<br/><br/>The internet began as a community of people wanting to share information — the time has come to bring back that vision of the internet using a cryptocurrency that truly fulfills Satoshi’s vision of a decentralized cryptocurrency with Skycoin.</p>',
    buy: '购买Skycoin ',
    wallet: '获取钱包',
  },
  newsletter: {
    heading: '注册接收天空链团队的更新',
    button: ' 注册',
    input: '输入你的邮件',
    skyminerOption: 'I\'m Interested in a Skywire Miner',
  },
  markets: {
    title: 'Buy Skycoin',
    loading: 'Loading, please wait...',
    description: 'Buy Skycoin',
    disclaimer: 'Please note that sending funds to crypto wolf before hitting "Start Transaction" will lead to transaction failure. Moreover, sending a different amount from the one indicated will also lead to transaction failure. Make sure that you have calculated the miner\'s fee in order to send the exact amount indicated',
    data: 'Market Data',
    contact: 'To list Skycoin and put your exchange here email ',
    video: '如何从 Skycoin.com直接购买天空币',
  },
  home: {
    title: 'Skycoin - Decentralize the Web',
    description: 'Skycoin is a new blockchain-based mesh-internet.',
    banner: {
      heading: 'Check out the Skycoin hardware gallery',
      button: 'View photos',
    },
    bannerStore: {
      heading: '今天就订购一台Skyminer吧！',
      button: 'Visit store',
    },
    hero: {
      heading: 'Skycoin是什么？',
      paragraph: 'Skycoin 平台是世界上最先进的区块链应用生态系统。Skycoin 由比特币和以太 坊的早期贡献者共同开发，它是一个完全安全、可无限扩展、并且独立于 ISP 的平台。Skycoin 以带宽、存储和算力作为后盾，旨在实现中本聪的最初愿景。',
      slider: {
        revolutionary: {
          title: 'Skycoin是一场革命',
          description: '一个从头开始构建的全新区块链生态系统',
        },
        obelisk: {
          title: 'Skycoin是Obelisk',
          description: '一种新的共识协议，解决了PoS和PoW共识协议中的低效问题。',
        },
        cx: {
          title: 'Skycoin是CX',
          description: '区块链的一种全新的、功能强大的图灵完备编程语言',
        },
        skywire: {
          title: 'Skycoin是Skywire',
          description: '更强大、更快速、更安全的互联网，网络协议和带宽路由算法',
        },
        fiber: {
          title: 'Skycoin是Fiber',
          description: '一个无限可扩展、完全可定制的平台，具有类似Visa的速度和安全性。',
        },
      },
      buy: '购买Skycoin',
      wallet: {
        get: '下载钱包',
      },
    },
    about: {
      obelisk: 'learn more about obelisk',
    },
    network: {
      label: 'Digging deeper',
      heading: 'Obelisk',
      subheading: '天空链共识算法',
      body: '在天空链，我们希望为用户提供他们所要求的：一个没有中央权威的真正的，去中心化的网络。为了完成这项任务，我们超越了PoW和PoS，创建了一个全新的去中心化算法，重新构造了区块链的内部运作。我们的分布式共识算法Obelisk成功地提供了这样一个网络。它的网络信任共识机制阻碍了集权的发展。 天空链不需要开采，对51％的攻击免疫，并且交易在数秒内发生。所有决定是通过社区共识，而不是基于少数利益相关者的意愿。',
    },
    miner: {
      heading: '探索Skyminer',
      subheading: 'Skyminer 矿机经过精心设计和配置，为Skywire基础设施提供了坚如磐石的电信主干 网。定制的硬件将为软件定义网络（SDN）提供最高级别的安全保障、效率和性能。 多板架构使每个节点都可以支持Skywire上的独立服务。通过隔离节点，每项服务即便 在遭遇外部服务攻击时也能安全运行。这些提供服务的节点由 OpenWRT 路由器管理，路由器具有严格的数据包转发和访问控制规则以提供额外的保障。为Skywire网络提 供服务和安全保障的Skyminer 会获得币时作为奖励。',
      link: 'Become a node',
      more: '了解更多',
      morePhotos: 'View more photos',
      headingHardware: 'Skycoin继续制造硬件套件',
    },
    press: {
      heading: 'Skycoin Picked As Top 5 Crypto Projects For 2018',
      subheading: '最值得关注的项目',
      forbes: 'Skycoin aims to provide a “new internet” that is global, decentralized, and not controlled by any country, corporation, or government entity.  For privacy gurus or net neutrality enthusiasts, this is a project to stay on top of.',
      huffingtonPost: 'Net neutrality and consumer data privacy emerged as two key issues in tech in 2017. If you’re concerned about paying ridiculous fees to ISPs for unreliable coverage, having your data sold, or government monitoring and censorship - Skycoin provides hope. These are the core issues Skycoin is attempting to solve.',
    },
    ecosystem: {
      heading: '天空链是世界上最先进的区块链应用平台',
      subheading: '天空链生态系统',
      fiber: {
        title: 'Fiber',
        text: '天空链平台的无限扩展和高度可定制的并行对等链体系结构。',
      },
      obelisk: {
        title: 'Obelisk',
        text: '“信任网”是一种解决PoW＆PoS基本缺陷的新型共识算法。',
      },
      skycoin: {
        title: '天空挖矿机',
        text: '坚不可摧的去中心化式互联网的硬件骨干。能持续不间断为你提供带宽，存储和CPU能力。',
      },
      coinHours: {
        title: '币时',
        text: '通过持有Skycoin获得，币时是Skycoin平台上的服务支付机制。',
      },
      coinJoin: {
        title: 'Coin Join',
        text: 'Native platform支持CoinJoin提供完全私密的，无法追踪的交易。',
      },
      skyledger: {
        title: 'Skyledger',
        text: 'Platform for launching your very own ICO on top of Fiber, our blockchain technology.',
      },
      skywire: {
        title: 'Skywire',
        text: '新型去中心化式互联网，一种无线多跳网络，给您提供支持。',
      },
      skyminer: {
        title: 'Skyminer',
        text: '坚不可摧的分散式互联网的硬件骨干。在不知道不觉间获得支付，以提供带宽，存储和CPU能力。',
      },
      nodes: {
        title: '节点',
        text: 'Skywire网络的构成部分，任何人均可部署节点以确保Skywire生态系统的去中心化。',
      },
      cx: {
        title: 'CX',
        text: '一种基于Golang的定制编程语言。易于学习且方便上手。',
      },
      cxo: {
        title: 'CXO',
        text: '专为服务Skywire分布式网络而设计的点对点云存储服务。',
      },
      kittyCash: {
        title: 'KittyCash',
        text: '目前建立在Fiber上的最流行的应用程序。 Kittycash是一个完全的游戏生态系统。',
      },
      skyVpn: {
        title: 'SDN',
        text: '通过Skywire网络内置端对端虚拟私人加密功能以确保隐私。',
      },
      skyMessenger: {
        title: 'SkyMessenger',
        text: '我们完全加密的信使服务，免于窥探和混进者。',
      },
      bbs: {
        title: 'BBS',
        text: '构建分布式社交网络服务的框架。',
      },
    },
    news: {
      heading: '新闻',
    },
    signup: {
      heading: '加入我们的Skyfleet通讯，和Skycoin一起到达新高度！',
      body: '订阅邮件以获取Skycoin团队的最新动向、信息更新。输入您的个人邮箱地址，即刻启航。',
      button: '注册',
    },
  },
  downloads: {
    title: '下载',
    description: '下载天空链钱包',
    wallet: {
      heading: '下载SKYCOIN钱包',
      headingDaemon: 'Download Skywallet Daemon',
      build: '目前为{version}.',
      macos: 'MacOS',
      linux: 'Linux',
      windows: 'Windows',
      android: 'Android',
      ios: 'iOS',
      androidRecommended: 'Google Play Store',
      androidRecommendedComment: ' (recommended)',
      iosRecommended: 'Apple iOS App Store',
      iosRecommendedComment: ' (recommended)',
      androidAdvanced: 'APK',
      androidAdvancedComment: ' (advanced)',
      withElectron: 'Installer',
      withElectronComment: ' (recommended)',
      withoutElectron: 'Portable',
      withoutElectronComment: ' (advanced)',
      download: '下载',
      instructions: 'Instructions',
      signature: '数字签名',
      torrent: 'Torrent',
      linuxDaemon: 'Daemon',
      linuxDaemonComment: '  ',
      macsDaemon: 'Daemon',
      macsDaemonComment: '  ',
      windowsDaemon: 'Daemon',
      windowsDaemonComment: '  ',
    },
    whitepaper: {
      title: 'Whitepapers',
      description: 'Skycoin wallet Whitepapers.',
    },
    bbs: {
      heading: '下载Skycoin BBS',
      lead: 'Skycoin BBS是使用Skycoin的区块链技术Fiber构建的下一代去中心化社交网络。',
      githublink: 'Github上找最新的二进制文档',
      thinclient: '前往BBS瘦客户机',
    },
    whitepapers: {
      heading: '下载Skycoin共识白皮书',
      download: '下载',
      cryptocurrencyNetwork: '加密货币网络分布式共识算法白皮书',
      skyFramework: 'Sky：在P2P网络上建立共识的观点动态框架和模型',
      skyHashConsensus: 'SkyHash：在P2P网络上建立哈希共识的观点动态模型',
      skyHash: 'SkyHash：哈希观点动态模型',
      sznajd2: 'Sznajd2: 具有社区意识的观点动态模型',
      distributedAlgorithm: '加密货币网络的分布式共识算法',
    },
    assets: {
      heading: '下载Skycoin品牌指南',
      guidelines: 'Skycoin品牌指南',
      logo: '天空链 Logo PNGs',
      sch_logo: 'Coin Hours Logo Assets',
      font: '天空链 Sans字体',
      branding: 'Skycoin v1.6.1',
    },
    skywire: {
      heading: 'Skywire',
      installationGuide: 'Skywire Installation Guide v1.0',
      minerAssemblyManual: 'Skywire矿机组装手册 v2.3',
      minerAssemblyManualHiRes: 'Skywire矿机组装手册 Hi-Res v2.3',
      skyminer: 'Skyminer矿机安装手册 v2.2',
    },
    roadmap: {
      heading: 'Roadmap',
    },
  },
  ecosystem: {
    title: '生态系统',
    description: '生态系统',
    heading: '生态系统',
    subheading: '新互联网的架构',
    skycoin: {
      heading: '天空链',
      body: 'Skycoin是为了解决比特币和以太坊的缺点而创建的。它的应运而生是由于当时还没有其他币种可以实现中本聪最初的完全去中心化数字货币的愿景。<br/><br/> 通过其专有的Obelisk共识算法，Skycoin的平台可以免于中心化和人为操控。它的特色编 程语言CX，允许成千上万的开发人员轻松地将应用程序部署到区块链上。Skycoin作为加 密货币，具有免费交易的功能，其绝对隐私功能即将落实，同时具有类似Visa支付处理系 统的速度，其价值基于内在资产支持而不是基于投机。<br/><br/> 持有Skycoin产生的币时可用于在Skywire网络上购买服务，并且可以兑换更多的Skycoin。',
      btn: '了解更多CX',
    },
    skywire: {
      heading: 'Skywire',
      body: '隐私：这意味着您在浏览时无法被追踪。 Skywire社区可以通过互联网服务来保护用户的 隐私，而不是像ISP那样每月支付巨额费用来追踪您，并在未经许可的情况下出售您的浏 览数据。<br/><br/> 激励：Skywire将发展成为无线网状网络（WMN）。用户可以同时赚取Skycoin和币时用来 运行为整个网络提供带宽和存储的硬件节点。用户还可以使用使用已赚取的币时，换得想 要的内容和其他网络资源。<br/><br/> 安全：Skywire由用户自己创建，且服务于用户。用户在基于信任系统运行的网络上做决定 ，通过社区的集体协议，将恶意节点从主Skywire网络中断。这个共识模型让Skywire免于 被攻击、剥削和操纵。<br/></br/> 在这个消费者一直被大公司以利益之名利用的时代，Skycoin的Skywire网络如一股清流。Skywire放权于民，与此同时创建一个更强大，更快速，更安全的互联网。',
      skywireBtn: '了解更多Skywire',
      cxoBtn: '了解更多CXO',
    },
    skyledger: {
      heading: 'Obelisk',
      body: '在集权的世界去中心化。<br/><br/>Obelisk在PoW和PoS算法缺陷中诞生。<br/><br/>Obelisk永远不可能被采矿池集中或被股东操纵，这意味着它是真正去中心化的。Obelisk根据信任网络架构在网络上分配影响力。网络由节点组成，而不是矿工。每个节点都有自己的个人区块链，可以阻止和隔离任何潜在的不良潜入者。与比特币或以太坊的传统矿工相比，这些节点的生产，采购和运营成本要低得多。Obelisk被设计成一个可扩展的，低成本运算，零污染替代PoW。这些功能使算法能够以可持续的方式在预算硬件上运行，而不会浪费电力或消耗宝贵的自然资源。当任何人都可以操作节点时，中心化几乎不可能。</p>',
    },
    experiments: {
      heading: 'Fiber',
      body: 'Fiber是天空链平台的无限扩展和高度可定制的并行同级链结构。Fiber是一种比区块链更好的解决方案，它可以解决现有的分布式账本技术问题。<br/><br/>Fiber是“区块链 3.0”的基础，可以描述为一个可无限扩展的区块链网络，像Strand（链）一样并排放置。 在Fiber上的每家公司、每个项目都拥有专用的、完全定制的私有区块链，其速度可媲美Visa，从而为运行私人或公司区块链的企业提供区块链解决方案，让企业实现自治，完全控制自己的链。加入到Fiber中的每条链增强了整个网络并构建了整个生态系统的结构。<br/><br/>天空链 Fiber不会与第一代和第二代加密货币架构竞争，而是取代它们。从刚刚起步的区块链项目到寻求解决方案的企业，Fiber就是终极答案。</p>',
      btn: '了解更多Fiber',
    },
    iconLabel: {
      fiber: 'Fiber 网络',
      coinHours: '币时',
      cx: 'CX',
      obelisk: 'Obelisk',
      coinJoin: '合币',
      skyminer: '天空矿机',
      node: '节点',
      cxo: 'CXO',
      bbs: 'BBS',
      skyMessenger: 'SkyMessenger',
      skyVPN: 'SDN',
      kittyCash: 'KittyCash',
    },
    about: {
      heading: '什么是天空链？',
      paragraph1: '数字货币的最初目的是重塑经济，使用户可以被独立授权以对等的方式进行交易，而不受中心机构的困扰。对天空链来说，这是我们的使命。这就是为什么天空链旨在让所有用户受益，而不仅仅是少数几个。通过Obelisk，我们正在解决PoW和PoS算法的固有问题，为你提供一个去中心化的民主共识网络。',
      paragraph2: '中本聪将比特币视为一种去中心化的数字货币。区块链网络旨在使金融民主化，消除大公司控制，使权力掌握在民众手中。然而，比特币和其他使用PoW/PoS算法，通过挖矿获得奖励的数字货币正在变得越来越中心化。这种中心化违背了数字货币发明的初心。',
      paragraph3: '所以我们创造天空链来弥补这些缺陷。 天空链区块链使用全新的一致性算法来替代PoW/PoS. 它还解决了与其他区块链网络连接的安全问题，并将新币产生和挖矿分开。天空链才是符合中本聪愿景的真正去中心化的数字货币。',
      paragraph4: '天空链区块链没有挖矿，所以权力不会像现在的比特币那样集中在几大矿池手里。新币产生不会给某些用户对网络不当的控制权。 天空链的总量固定，交易速度是秒级而且安全的。我们创造了天空链，一个不可变的加密货币，作为数字财产而非控制网络的政治工具。',
    },
    roadmap: {
      dev: {
        heading: '天空链发展路线图',
      },
      marketing: {
        heading: 'Skycoin Marketing Roadmap',
      },
    },
  },
  skyminer: {
    title: '探索天空矿机',
    description: '天空矿机：下一代互联网硬件',
    hero: {
      heading: '天空矿机：<br/>下一代互联网硬件',
    },
    about: {
      heading: '探索Skyminer',
      subheading: 'Skywire矿机：新一代互联网的硬件设备',
      paragraph1: 'Skywire矿机经过精心设计和配置，为新一代互联网的构建提供支柱。它的定制 硬件设备超越了现有的技术规格，提供最大的功率和性能。Skywire类似一台获 取Skycoin的矿机。它作为一个专门的虚拟专用网络，具备以下硬件配置：',
      paragraph2: '每个主板都配有ARM处理器、2 GB RAM、以及32～256 GB的闪存。这样分割硬件的做法在一个服务损坏的情况下，同一台计算机上的其他服务将不受影响。一个具有严格数据包转发规则和访问控制的OpenWRT路由器提高了安全性。该套配置可进一步定制以容纳4、8、16或32个主板。',
      paragraph3: '在Skywire网络中运行的节点除了获得转发流量的报酬外，还将获得网络激励奖 励以帮助建立网络。对于Skywire矿机，我们希望能提高这种网络激励奖励。然而，我们仍在制定区分Skywire矿机与其他节点的机制，这些节点可能是网络中 的任何机器。',
      list: {
        item0: '8个CPU主板',
        item1: '每块主板拥有2 GB RAM',
        item2: '每块主板拥有4个CPU内核',
        item3: '每块主板拥有64 GB的存储空间',
        item4: '64位Linux系统（Debian）',
        item5: '千兆以太网，8 + 1端口交换机',
      },
    },
    video: {
      heading1: '什么是天空矿机',
      heading2: '天空矿机简介',
      heading3: '天空矿机拆箱',
      more: '更多视频',
    },
    gallery: {
      heading: '天空矿机展示',
    },
    signup: {
      heading: '加入天空矿机候补名单',
      body: '在下一代互联网上给你的未来留一个位置，就是现在！',
    },
  },
  roadmap: {
    title: 'Skycoin Roadmap',
    description: 'Skycoin Roadmap',
    heading: 'Skycoin Development Roadmap',
  },
  skywire: {
    title: 'Skywire',
    description: 'Skywire - The Foundation of a New Internet',
    about: {
      heading: 'Skywire是什么？',
      subheading: 'Skywire创立了新的互联网 ',
      quote: '每个人都可以为Skywire做贡献并从中受益。',
      paragraph1: 'Skywire是互联网开发和使用的下一个革命化阶段。我们希望打破互联网服务提供商 ISP）对市场的垄断，让用户拥有自主权。我们正在通过提供分散的社区驱动的网状网络 来实现这一点，用户自己将拥有和控制网络的基础设施。我们的目标是为每个人提供快速 ，安全，私密和可信赖的互联网。',
      paragraph2: '现在是时候把ISP抛在脑后向前看了。传统互联网中，客户经常会被跟踪，其浏览数据会被 ISP存储、售卖，同时也面临着不可靠的网络覆盖和糟糕的客户服务。而Skywire网状网络 并不是依赖于公司所有的网络，而是运行在广泛的用户拥有的节点上，这些节点聚集在一 起为网络提供基础设施，使社区能够接入互联网。',
    },
    features: {
      heading: 'Key Features:',
      speed: {
        title: '速度快',
        text: '我们在使用现有的ISP服务时，都曾遇到过网络延迟、中断和节流问题。Skywire的协议基于软件定义网络，这将使过时和低效的“热土豆”（hot-potato）路由成为历史。Skywire支持频道绑定，实现无与伦比的快速连接，且具有高度的可靠性，能一次连接到多个节点，大大提高其吞吐量和冗余，使之前难以实现的应用场景实现民主化。',
      },
      privacy: {
        title: '保护隐私',
        text: '通过默认的端到端加密，Skywire确保所有流量都是私密的，用户的数据永远不会被跟踪、存储、出售。第三方无法将单个数据包连接到任何用户或IP地址，并且他们将无法读取网络中的任何内容。中继节点仅可获得用于加密数据包传输的前一个和后一个节点的路由信息。 用户最终能在上网的同时其隐私能获得真正的保护。',
      },
      security: {
        title: '安全性高',
        text: '今天，互联网用户对于ISP的运营方式没有任何发言权。Skywire通过网络信任系统重新赋予用户决策权。在共识模式下，当节点被认定为恶意节点时，会被切断，如果改节点通过社区集体达成共识被认为是可信的，其连接就会获得增强。通过确保每个人都有发言权，Skywire不会被利用、操纵和攻击，并且对所有用户而言都更为安全',
      },
      ecosystem: {
        title: '自给自足的生态系统',
        text: 'Skywire的骨干为社区本身。通过向节点运营者提供Skycoin和币时奖励，我们采取激励措施，鼓励用户为网络做出贡献，相应地，他们将获得币时，使用币时可获得网络上的资源和应用服务。网络被使用得越多，它就越强大、越快、越稳健，从而创建一个闭环、自给自足的生态经济体系。',
      },
      internet: {
        title: '一个全新的互联网的基础',
        text: 'Skywire为分布式带宽、存储和计算奠定了基础，这对于新的P2P网络来说至关重要。未来，用户将以低廉的价格购买到这种三合一的数字商品，并且可以通过Skywire轻松访问到全球的信息。在不久的将来，Skywire与无处不在的Skywire矿机将提供节点，让将运行在Skycoin架构上的无数区块链应用实现高效去中心化运作。',
      },
    },
  },
  cxo: {
    title: 'CXO - CX Object Systems',
    description: 'CXO - CX Object Systems',
    about: {
      heading: 'CXO是什么？',
      subheading: 'CX对象系统',
      quote: 'Skycoin正在创建一个新的生态系统，包括以下部分:',
      paragraph1: 'CXO（CX对象系统）是不可更改的Skycoin对象系统，之前称为Aether。CXO旨在取代目 前传统的点对点共享方式，创造一个强大的存储系统，取代BitTorrent、Dropbox和Google Drive等服务，通过使用Skycoin CXO库对数据进行点对点复制。',
      paragraph2: 'CXO整合并扩展了其他基于区块链的存储网络所使用的协议。CXO是一个有内置模式的 IPLD，这种模式可以用来约束和对关联数据库进行分类。星际文件系统（InterPlanetary File System, IPFS）可以构建于CXO之上。CXO提供的数据分布在Skywire网络上，有助 于实现数据安全、可验证，且不必存储在区块链上。',
      skywire: {
        title: 'Skywire',
        text: 'Skywire-点对点 社区驱动 去中心化',
      },
      cx: {
        title: 'CX',
        text: '规范和编程语言',
      },
      cxo: {
        title: 'CXO',
        text: '实现数据共享，用于存储应用程序的低级库',
      },
    },
    features: {
      heading: 'Key Features:',
      sharing: {
        title: '数据共享',
        text: '对于想要共享信息的数据所有者而言很有帮助，因为它可以共享许多信息，如公钥。 CXO节点可订阅信息源以接收更新信息，并可使用发现服务器进行连接，从而根据兴趣连接获得数据。',
      },
      privacy: {
        title: '保护隐私',
        text: 'CXO数据集中存在于网络上。一旦数据发布，它就不能被销毁，并且数据将被对等用户（订阅者）下载。 为了保护隐私，发布者的位置不能被追踪，因为发布者仅仅是去中心化网络上的一个点（对等用户）。',
      },
      security: {
        title: '安全性高',
        text: 'CXO存在于自给自足的标准生态系统，该生态系统数据精准，是一个从零开始打造的生态系统。 所有者使用私钥签署数据，接收数据的用户可以使用公钥来审核签名，以确保数据来自设想的信息所有者。若没有数据所有者私钥，节点不无法对数据进行更改，从而保障数据的安全。',
      },
      apps: {
        title: 'CXO应用',
        text: 'CXO上的应用目前正在进行少量测试。SkyBBS是一个类似于Facebook、Steemit和Twitter的社交网络，且建立在CXO上。敬请期待即将发布的更多应用。',
      },
    },
  },
  cx: {
    title: 'CX - CX programming language',
    description: 'CX - programming language',
    about: {
      heading: 'CX是什么？',
      subheading: '编程语言',
      paragraph1: 'CX是Skycoin的规范和编程语言，其中包含许多功能。CX可以改进Skycoin项目的诸多部分。为了增加安全性，CX允许创建复杂的合同协议。',
      paragraph2: 'CX将为在该平台上构建的项目部署可修改的功能。这些属性都是CX多功能编程语言的一部分：',
    },
    features: {
      heading: 'CX的特点：',
      affordances: {
        title: '功能可见性',
        text: '功能可见性允许许可包被特定用户同意或拒绝，从而有助于程序员安心地创建安全代码。可以通过查询可供性系统以获得可以引起相关功能的动作列表。',
      },
      programming: {
        title: '遗传编程（GP）',
        text: '遗传编程是在CX中创建程序时演变而来的。作为一种机器学习工具，GP将通过提供自动解决问题的引擎以及执行曲线拟合和创建预测模型的能力来帮助程序员。',
      },
      deterministic: {
        title: '确定性的语言',
        text: '确定性允许CX程序能够被可靠地创建，从而无需程序员关注嵌入式环境中的底层机器，因为无论机器如何都会产生输出。',
      },
      typing: {
        title: '严格的打字系统',
        text: 'CX严格的打字系统提供了另一层保护以及冗余和易用性，使调试过程简单明了。清晰的类型转换可以减少错误，并使CX对程序员从本质上来说是安全的。',
      },
      complied: {
        title: '编译和解释语言',
        text: '既可以作为编译语言，也可以作为解释语言。这使程序员能够利用其高级功能结合灵活和交互的附加功能。',
      },
      garbage: {
        title: '垃圾收集器',
        text: '作为一种自动内存管理形式，CX垃圾收集器会自动回收队列中未被使用的对象，从而释放宝贵的内存以进行必要的操作。CX在程序中查找将来无法访问的数据对象并将其处理掉。',
      },
      object: {
        title: '对象资源管理器',
        text: '程序员可以访问对象资源管理器，它将显示所有对象及其当前内存分配的图形视图。这些对象可以被序列化和传递，而代码步进将允许程序员在观察到的最后状态下继续执行这些对象。',
      },
    },
    roadmap: 'Skycoin Roadmap',
  },
  jobs: {
    title: 'Skycoin is hiring developers.',
    subtitle: 'We are hiring',
    sidebarTitle1:
      'Apply for a job by sending an email to jobs@skycoin.com with the following information:',
    sidebarTitle2: 'with this information:',
    sidebarList: {
      item_1: 'Position desired',
      item_2: 'Name',
      item_3: 'Time zone',
      item_4: 'Full-time or part-time',
      item_5: 'Telegram username',
      item_6: 'Resume (PDF)',
    },
    ourProject:
      'All of our projects are developed in Go and C. For frontend work, we use ',
    angular: 'Angular',
    or: ' or ',
    react: 'React.js.',
    ourTeam:
      'Our team is spread across the world and you will be working either remotely or at one of our offices in Shanghai. We communicate using',
    accordion1: {
      title: 'Technical Writer',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Work on a remote team to create articles to communicate technical progress to readers',
        item2: 'Create and update technical documentation',
        item3: 'Create user manuals for various Skycoin projects',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Excellent English reading and writing skills as well as previous experience with technical writing.',
        item2:
          'Knowledge of concepts and technologies used in the software development process.',
      },
    },
    accordion2: {
      title: 'Software Engineer (Backend)',
      description:
        'Work on a fully remote team developing blockchain-, networking- and infrastructure-related software. Experience writing in Go (Golang) required.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion3: {
      title: 'Firmware Engineer',
      description:
        'Work on a fully remote team developing firmware and embedded software for various hardware projects.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion4: {
      title: 'Circuit Engineer',
      description:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Draw PCB Design drawing and circuit schematic diagram according to product requirements;',
        item2:
          'Edit the instruction documents for production, such as BOM format and screen mesh;',
        item3:
          'Carry out the selection of components and be in tune with suppliers on product supply;',
        item4: 'Carry out type testing and reliability testing;',
        item5: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in electronic engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Process the ability to proficiently design analog circuits and digital circuits, and read and draw schematic diagram skillfully;',
        item4:
          'Use Altium Designer or other same type software skillfully in response to the independent conduct for layout design of four-layer PCB board.',
        item5:
          'Possess the strong ability to circuit adjustment and test, and use common instruments skillfully;',
        item6:
          'Have a certain understanding of the model and supply chain of ordinary electronic components;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on Electronics Industry or the English-speaking proficiency;',
        item2:
          'Enable to use SolidWorks and other same types of 3D modeling software and to read mechanical drawings;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4:
          'Have knowledge or experience in any one of the following three sectors--- the Internet of things, communication, and integrated circuits;',
        item5: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one work about PCB Design, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion5: {
      title: 'Mechanical Engineer',
      description: 'Description',
      study:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Engage in design, study and optimization for the structure of mechanical products, creation of products, and improvement of product performance and quality;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Solve problems during product development work and meet new requirement from users;',
        item4:
          'Provide the volume production of products with relevant technical data;',
        item5:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in mechanical engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Use SolidWorks or related software proficiently in response to the independent conduct for establishment, modification and derivation of model. Experience in designing and managing model documents with components whose total volume is more than 100 are preferred;',
        item4:
          'Understand the supply chain of ordinary mechanical components well;',
        item5:
          'Think clearly, take initiative in working process with the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
        item6: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on machinery industry or English-speaking proficiency;',
        item2:
          'Understand circuit knowledge and use Altium proficiently for completing the PCB Design;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4: 'Understand the knowledge of blockchain well;',
      },
      propgram: {
        title: 'Internship Program',
        item1:
          'Submit at least one model completed by using Solidworks, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion6: {
      title: 'Industrial Designer OR Intern',
      description: 'Description',
      subtitle:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'New product exterior design and 3D modeling;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Provide the volume production of products with relevant technical data;',
        item4:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in product design or related discipline;",
        item2: 'Have had one-year experience working in relevant sector;',
        item3: 'Have fluent English speaking, reading and writing;',
        item4:
          'Use SolidWorks or relevant 3D modeling software skillfully in response to the independent conduct for establishment, modification and derivation of model.',
        item5:
          'Possess the ability to be familiar with processing technology of common materials, and have a certain understanding of the supply chain for relevant parts;',
        item6:
          'Possess the ability to outstanding aesthetic judgment and creative thinking skill, take initiative in working process, good cooperation spirit and will of study. ',
        item7: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to read mechanical drawings or electrical drawings;',
        item2:
          'Use Adobe Illustrator or other same type graphic design software proficiently;',
        item3: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one design work completed independently and its introduction;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion7: {
      title: 'Blockchain Internship Engineer',
      description:
        'Carry out 90% of the tasks in English and work together with English-speaking members making up 80% of total team members. Good communication skills and proficiency in English are requirements for admission; experiences in large international companies are preferred. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Study the principle of blockchain, operation mechanism and relevant algorithms;',
        item2:
          'Take part in the design, development and testing of blockchain products;',
        item3:
          'Solve problems during development and testing, and provide technical support for products;',
        item4: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Undergraduates and fresh graduates majoring in computer science, software engineering, or related specialists;',
        item2:
          'Process the outstanding ability to excellent communication skills and good English reading and writing skills, and to learn code and relevant technical materials well;',
        item3:
          'Be passionate about the programming, be fond of studying technique, and be strongly interested in the blockchain technology;',
        item4:
          'Be proficient in at least one of the following sectors--- C/ C++, JAVA, GoLang, and Swift Programming Language development, and have good habits of programming and proficiency in file compilation;',
        item5: 'Have experience in developing Linux platform;',
        item6:
          'Master the technique in data structure and algorithm, and be familiar with network protocols such as TCP/IP, HTTP and P2P;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in excellent self-study, and maintain good teamwork spirit.',
        item8:
          'Submit your GitHub account and at least one work, and relevant cites must be marked if any;',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with relevant professional English vocabularies, and to communicate and express English freely;',
        item2:
          'Have experience in research, development and practitioner of the projects related to blockchain;',
        item3:
          'Have experience in the network protocol development, such as DNP, P2P, etc. ',
      },
    },
    accordion8: {
      title: 'Operations Manager',
      description:
        'This is a flexible position. The operations manager will be responsible for improving internal business processes and leading teams for various business goals as needed. Strong communication and organizational skills are required. Work position is remote or on-site in Shanghai.',
    },
    accordion9: {
      title: 'Marketing Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Build, optimize and scale effective marketing campaigns to drive growth across digital marketing channels',
        item2:
          'Identify and test new innovative growth opportunities to deliver on goals',
        item3: 'Collaborate with internal teams / vendors',
        item4: 'Manage performance metrics and budget tracking',
        item5:
          'Generate and create data driven hypotheses to execute experiments across the marketing funnel to optimize conversion and other key performance metrics',
        item6:
          'Execute global marketing strategies with integrated campaigns focusing on user acquisition and brand awareness',
        item7:
          'Coordinate with content writers and social media manager to ensure message consistency across various channels',
        item8:
          'Tell stories with data, transforming it into insightful and easy to interpret visuals',
        item9: 'Maintain brand voice, design and messaging',
        item10:
          'Work closely with the Product and Engineering teams to launch features and products',
      },
    },
    accordion10: {
      title: 'Social Media Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'Represent our brand on social media channels',
        item2:
          'Deliver engaging and inspiring messages to our social audiences, with the goal of driving brand awareness and consideration',
        item3: 'Significantly grow our audience on social media',
        item4: 'Define and implement paid and organic growth strategies',
        item5:
          'Turn our high level marketing strategy into a social media strategy and calendar',
        item6: 'Prioritize between channels, posts and messages',
        item7:
          'Work together with influencers, internal, and external teams to build social content that engages and inspires large customer audiences',
        item8: 'Scale our social content across multiple markets and languages',
        item9: 'Drive engagement with our social community',
        item10:
          'Ensure communication excellence and convert audience feedback into reputation/brand-building moments',
        item11:
          'Drive and develop customer understanding through insightful analyses and actionable reporting',
        item12:
          'Work closely together with the marketing manager to drive a consistent and differentiated brand message to a mix of countries and audiences',
      },
    },
    accordion11: {
      title: 'Content Writer',
      requirements: {
        title: 'Requirements',
        item1: 'Strong knowledge in various media and marketing channels',
        item2: 'Must be able to write content that is SEO friendly',
        item3:
          'Candidate needs to be self-motivated, detail-oriented, problem solving and able to work as a team with staff and administrators; have excellent communication and organization skills',
        item4: 'Must have a popular blogging experience',
        item5: 'Highly proficient in Cryptocurrency and blockchain technology',
        item6: 'Adobe Photoshop basic skills',
        item7: 'Creative thinking skills',
        item8:
          'Strong proficiency in the English language and excellent writing skills',
        item9:
          'Ability to translate complex technical concepts into easily comprehensible articles',
        item10: 'Excellent writing, analysis, and research skills',
      },
    },
    accordion12: {
      title: 'SEO Engineer',
      description:
        'The SEO Engineer will devise and implement SEO strategies on our website properties and in external SEO campaigns.',
    },
  },
  whitelist: {
    heading: 'Skywire Testnet Reward Application Form',
    signUp: {
      title: 'Get Connected, Join Skywire Testnet & Get Rewarded!',
    },
  },
  fiber: {
    title: 'Fiber',
    description: 'Fiber is Blockchain 3.0 Innovation with Advanced Peer-Chain Architecture',
    about: {
      heading: 'Fiber是什么？',
      subheading: '区块链3.0创新与平行链架构',
      quote: '“Skycoin的Fiber架构是一种转型，是优于区块链的解决方案，它使用分布式账本技术解决了现有问题。Fiber是区块链3.0的基础，可以最好地描述为一个无限可扩展的区块链网络，就像股线一样。这是一项技术壮举，比特币或以太坊等加密货币永远无法实现，因为它们从未被设计为无限扩展。“',
      author: '来自媒体',
      paragraph1: 'Fiber是Skycoin区块链平台的结构层，可定制，以适应任何区块链应用的需求。凭借创新且极其高效的代码，Fiber使Skycoin平台能够通过区块链解决方案适用于每个行业。',
      paragraph2: 'Fiber复杂而精妙，能够无限地扩展并满足多种类型分布式应用的需求。',
    },
    features: {
      heading: 'Fiber的优势',
      system: {
        title: '真正共生的平行链系统',
        text: 'Skycoin Fiber的架构可以横向和纵向扩展Skycoin平台，且不会因此大规模地影响网络独立性或造成网络缺陷。由于Skycoin的Obelisk共识机制，Fiber上的各个应用支持的代币将从根本上与其他代币隔离，使得各应用在网络稳定性，安全性或吞吐量方面永远不会相互影响。此外，通过Skycoin币时系统，每个使用Fiber的应用都将推动整个Skycoin平台前进，而不会妨碍现有的平台运营。Fiber在各个应用之间创造了前所未有的共生平衡，同时保持足够的隔离，使得任何一个应用都不会对网络的其余部分产生负面影响。',
      },
      forking: {
        title: '链可以分叉',
        text: '在Fiber上的所有代币将成为Skycoin核心代码的分支，这意味着每个应用都将具有与Skycoin相同级别的高级功能，吞吐量与安全性。',
      },
      blockchain: {
        title: '定制区块链',
        text: '在Skycoin Fiber上运行的项目将拥有自己完全独立且高度可定制的区块链，以满足不同项目的独特需求。寄希望于一组规则或操作能满足不同项目的要求，从根本上说，这是一种很天真的想法。但这也意味着，如果区块链平台要成功地纵向和横向扩展，适应性是平台中最关键的因素。',
      },
      token: {
        title: '真正的代币支持',
        text: '基于Skycoin Fiber架构构建的项目将具有前所未有的网络支持水平。项目将能够在我们开创性的点对点网络Skywire上运行，每个项目将在Skycoin生态系统中立即获得钱包和交易支持。没错，项目可以在几分钟内在我们的世界级平台上启动和交易。',
      },
      operation: {
        title: '独立运作',
        text: '随着Skywire发展成为全球点对点网状网络，在Fiber上运行的应用将完全独立于对互联网服务提供商等传统网络基础设施的依赖。这种平台独立性是Skycoin的Fiber及其分布式应用程序和项目所独有的。',
      },
    },
  },
  skyminerForm: {
    title: 'Skyminer Order Information',
  },
  obelisk: {
    title: 'Obelisk是什么',
    description: '革命性的SKYCOIN共识算法',
    about: {
      heading: 'Obelisk是什么？',
      subheading: '革命性的SKYCOIN共识算法',
      quote: '“中心化的问题，51％的攻击，挖矿问题，缓慢的交易速度和能源浪费是旧的共识算法面临的一些关键缺点。为了解决这些问题，Skycoin开发了Obelisk，这是一种新的分布式共识算法，可以解决前几代共识算法的问题。”',
      author: '来源于媒体',
      paragraph1: 'Obelisk是一种革命性的共识算法，基于“信任之网”，旨在消除前几代共识算法给区块链带来的问题。信任之网架构创建了一个完美的检查和平衡系统，使社区和其他节点能够高度准确地审核网络行为。',
      paragraph2: '由于能够切断可疑节点的恶意行为，网络会随着信任的增强而变得越来越强大。节点的隔离可以管理信任，同时，此过程允许社区重新平衡网络中的能力。',
    },
    features: {
      heading: 'Obelisk的特点',
      consumption: {
        title: '低能耗和高度可扩展性',
        text: 'Obelisk共识算法是可扩展的且计算成本低廉, 是工作量证明（PoW）的替代算法。Obelisk使算法和区块创建能够在预算开源的硬件上运行。',
      },
      attack: {
        title: '抵御51%攻击',
        text: '网络信任共识阻碍了中心化权力的发展。Skycoin不依赖采矿激励，因此不会受到相同的PoW / PoS漏洞的影响。',
      },
      defence: {
        title: '有力地抵御协同攻击',
        text: 'Obelisk可以抵御大规模、有组织的恶意节点网络协同攻击。该算法是非迭代的，能快速收敛，可以在只有近邻连接的稀疏的网络（如网状网络）上运行，也能在连接图 （即不需要DAG-type连接）的周期里很好地运行。',
      },
      structure: {
        title: '存在两种类型的节点 ',
        text: '一个共识节点从一个或多个成块节点接收输入。每个节点的算法是独立的，但它们都在相同的数据结构上运行。两种类型节点一直对数据来源进行验证，检测欺诈性数据。欺骗性的或无效的消息被检测到，会被除掉，且永远不得传播——参与可疑活动的对等节点会被切断，其公钥也被禁止使用。',
      },
    },
  },
  gallery: {
    title: 'Gallery',
    description: 'Gallery',
    heading: 'Gallery',
    antennas: {
      heading: 'Biquad Yagi Antenna',
    },
    wallet: {
      heading: 'Skywallet',
    },
    skyminer: {
      heading: 'Skyminer',
    },
    diySkyminer: {
      heading: 'DIY Skyminers',
    },
  },
  landing: {
    skyware: {
      hero: {
        title: 'Skywire',
        heading: 'Skywire is the next evolutionary step in the internet’s development and use. Our goal is to provide everyone with access to fast, secure, private and reliable internet.',
        button: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skywire',
        youtube: {
          what: 'What is Skywire?',
          solution: 'A Solution to Censorship',
          isp: 'Why ISPs need to be Replaced',
        },
      },
      afee: {
        text: '“To free Crypto from the bonds of corrupt power, we need more than distributed exchanges. We need to bypass the existing Internet. Mesh networks solve this problem. Skywire  is the only one designed by and for the Crypto Space.” ',
        name: 'John McAfee',
      },
      divider: 'Everyone will be able to contribute to and benefit from Skywire',
      bottom: {
        text: 'Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. Join over 1,450+ nodes now on Skywire with our current special promotion!',
      },
      features: {
        speed: {
          title: 'Speed',
          description: 'Skywire’s protocol is based on software-defined networking, which will make the outdated and inefficient  “hot-potato” packet routing a thing of the past.',
        },
        privacy: {
          title: 'Privacy',
          description: 'With default end-to-end encryption, Skywire ensures that all traffic is private and users will never have  their data tracked, stored, or sold.',
        },
        security: {
          title: 'Security',
          description: 'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system.',
        },
        ecosystem: {
          title: 'Self-sustaining ecosystem',
          description: 'By providing Skycoin and Coin Hour rewards to  node operators, we offer incentives for people to contribute to the network.',
        },
        internet: {
          title: 'Foundation of the new internet',
          description: 'Skywire lays the foundation for distributed bandwidth, storage, and computation essential to the new  peer-to-peer internet',
        },
      },
    },
    cx: {
      hero: {
        title: 'CX',
        heading: 'CX is Skycoin\'s specification and programming language, packed full of features. It allows for the creation of complex contractual agreements that are build with security in mind.',
        button1: 'Download now',
        button2: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description: 'Check out the video below to get an introduction on the CX programming language by the lead developer Amaury Aguila. ',
        youtube: {
          introduction: 'CX Introduction',
        },
      },
      start: {
        title: 'Start now!',
        description: 'Download CX now and start working on a project.  Join the CX group on Telegram to share your work, get help, gain inspiration and much more.  There is even a group dedicated to making games with CX.',
      },
      divider: 'CX will provide numerous advancements within the Skycoin project.',
      features: {
        affordance: {
          title: 'Affordances',
          description: 'The utilization of affordances allows the permission of packages to be granted or rejected from specific users, aiding in the ability of programmers to confidently create secure code.',
        },
        typing: {
          title: 'Strict typing system',
          description: 'Explicit type casting reduces errors and makes CX constitutionally secure for programmers.',
        },
        object: {
          title: 'Object explorer',
          description: 'Programmers will have access to an object explorer which will show a graphical view of all objects and their current memory allocation.',
        },
        more: {
          title: 'More features...',
          list: {
            deterministic: 'Deterministic language',
            compiled: 'Compiled & interpreted language',
            extensive: 'Extensive documentation',
            active: 'Active development',
            videogame: 'Video game development',
            system: 'Mac, Linux and Windows support',
          },
        },
      },
      bottom: {
        text: 'Start developing now with CX. Either download it from Github or try the CX playground.',
        button1: 'Download',
        button2: 'CX Playground',
      },
    },
    skywallet: {
      hero: {
        title: 'Skywallet',
        heading: 'Your hardware multi-coin wallet is your bank vault and it should feel like a premium and secure device.  Shipping Q1 2019. Order now!',
        button: 'Order now',
      },
      features: {
        live: {
          title: 'Skywallet Live',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        },
        security: {
          title: 'Security',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        support: {
          title: 'Customer support',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        intuitive: {
          title: 'Intuitive',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        included: {
          title: 'Included',
          description: 'TODO',
        },
      },
    },
    skyminer: {
      title: 'Skyminer',
      description: 'Skyminer',
      hero: {
        title: 'Skyminer',
        heading: 'The Skywire "miner" is meticulously designed and configured to provide a backbone for the new internet.',
        button: 'Learn more',
      },
      hardware: {
        title: 'Hardware',
        description: `
          <li>8 CPU boards</li>
          <li>2 GB of RAM per board</li>
          <li>4 CPU cores per board</li>
          <li>16 GB of storage per board</li>
          <li>64-bit Linux (Alpine Linux)</li>
          <li>100 Mbps Ethernet, 8+1 port switch</li>
        `,
      },
      operate: 'Operate your Skyminer on the Skywire network to <b>get paid</b> SKY for free!',
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skyminers',
        youtube: {
          video1: 'What is a Skyminer?',
          video2: 'Unboxing the Skyminer',
          video3: 'Introducing the Skyminer',
        },
      },
      support: {
        title: 'Excellent support',
        description: 'When purchasing a Skyminer you will get access to fast email support from our help desk ticket system.  Our Telegram community offers help as well with over 2000 members.',
      },
      orderNow: {
        text: `Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. 
          Join over 1,450+ nodes now with our current special promotion!`,
      },
      forbes: {
        description: '“Skycoin aims to provide a new internet that is global, decentralized, and not controlled by any country, corporation or government. For privacy gurus or net neutrality enthusiasts… this is a project to stay on top of.”',
      },
    },
  },
  exchanges: {
    any: 'Any',
    title: 'Exchanges',
    description: 'Exchanges',
    exchanges: 'Exchanges',
    empty: ' ',
    lbank: 'LBank',
    c2cx: 'C2CX',
    bitbns: 'Bitbns',
    xbts: 'XBTS',
    coindcx: 'CoinDCX',
    table: {
      headers: {
        name: 'Name',
        link: 'Link',
        markets: 'Markets',
      },
    },
  },
  pressreleases: {
    any: 'Any',
    title: 'Press Releases',
    description: 'Press Releases',
    pressreleases: 'Press Releases',
    releases: {
      title: 'Skycoin Announces Public Release of Skywire Mainnet',
      description: 'Skycoin Announces Public Release of Skywire Mainnet',
      dates: 'March 20, 2019',
      content: {
        description: '<p>Skycoin has unveiled the developer version of their Skywire application. Developers will now be able to download, install, build, and run the Skywire mainnet utilizing a command line interface. Full developer documentation will be released over the next few weeks.</p><p><strong>SHANGHAI, March 19, 2019 /PRNewswire/ </strong>-- Work on Skycoin began in 2011 with the merging of three separate projects that aimed to improve upon the design and implementation of Bitcoin. The Skycoin developers identified several major philosophical design issues that they saw as obstacles to global use of cryptocurrency as a censorship-resistant payment system.</p><p>Skywire, the decentralized internet protocol and mesh network, was created as a solution to answer many of these problems.</p><p><strong>Skywire Mainnet is here for Developers to Test</strong></p><p>After about ten months of intensive testing on a network of nearly 10,000 nodes spanning the globe, Skycoin is happy to announce that the developer version of Skywire&apos;s mainnet is now available to the public. Its official launch date was the 4th of March 2019.</p><p>This first iteration of Skywire&apos;s mainnet features entirely rewritten software from the ground up and is primarily focused on a platform for developers to start building the next generation of distributed apps. All existing apps have been rewritten and optimized for the mainnet including a distributed and secure chat app, SSH, and a multi-hop tunneling proxy app. Many more will be coming soon.</p><p> <a href="https://www.blog.skycoin.com/posts/skywire-mainnet-public-testing-announcement/" rel="noopener noreferrer" target="_blank">This first version of Skywire&apos;s mainnet represents a huge milestone for Skycoin and for the future of the internet.</a> Skywire will serve as an unstoppable, highly resilient network, removing any possibility of censorship. </p><p>Skywire mainnet&apos;s developer build is the first release of many. Over the course of the next few months, Skycoin will be releasing new iterations and features for Skywire – one of these is an updater that allows Skycoin to push new features constantly – stay tuned for additional information, technical details, and further updates from the team.</p><p> <a href="https://github.com/skycoin/skywire/tree/mainnet" rel="noopener noreferrer" target="_blank">Skywire Mainnet on Github</a> </p><p>Please note: Do not install this on your skyminers as they are running testnet and will stop receiving rewards. Skywire mainnet can be installed on any other device to run, test and develop.</p><p>Bug reporting should be done through the repo, with steps taken to reproduce any feedback. Details of the process will be available in the readme section of the branch.</p><p><strong>What&apos;s Next for Skywire?</strong></p><ul> <li>A new and intuitive UI for developers and users to easily interact with the mainnet</li><li>Bandwidth monetization will be coming soon that will allow users to earn Coin Hours through bandwidth sharing</li><li>Coin Hours bank</li><li>Private Skycoin transactions utilizing CoinJoin</li><li>Remote management of unlimited nodes</li><li>Combining the CXO protocol with Skywire for distributed data storage</li></ul> <p><strong>About Skycoin</strong></p><p>Skycoin is a third generation blockchain company that has its own chain, consensus algorithm, programming language, hardware, and their flagship product Skywire which is a decentralized community-driven mesh network where users themselves will own and control the network&apos;s infrastructure. Skywire&apos;s goal is to provide everyone with access to fast, secure, private and reliable internet.</p>',
      },
    },
    releases_october: {
      title: 'Skycoin Project Releases Hardware Development Kit (HDK) for New Cryptocurrency Wallet',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skycoin is the first cryptocurrency to issue its own hardware wallet, along with a Hardware Development Kit to extend functionality</p><p>Shanghai, China / October 14th, 2019 / The Skycoin Project is pleased to announce the release of a Skywallet Hardware Development Kit (HDK) to anyone interested in extending the functionality of Skywallet, Skycoin’s sleek new hardware cryptocurrency wallet. The HDK is a developer-friendly version of the Skywallet, modified to facilitate programming and testing new code.</p><p>The Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold additional major currencies, including Bitcoin, Ethereum, and more. But with thousands of cryptocurrency coins, tokens, and other assets available for trade, Skycoin wanted to ensure motivated developers had the opportunity to build support into Skywallet for their favourite cryptocurrency.</p><p>The support for additional cryptocurrencies may be accomplished using the HDK and then rolled out to Skywallet users in an optional firmware update, pending approval. The HDK may also be used to create applications that can run on Skywallet. For instance, if a developer wishes to use Skywallet as an authentication device, they could use the HDK to develop that functionality.</p><p>"We made Skywallet the most affordable hardware wallet on the market because we think crypto investors deserve the best security for their investment," said a spokesperson for the project. "We also know there are a lot of cryptocurrencies, and we wanted to give developers the chance to extend the power of Skywallet to their own favourite crypto coin or token."</p><p>The developer-friendly nature of Skywallet extends beyond the Hardware Development Kit to the firmware of the Skywallet itself, which is completely open-source. This means that the security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">github</a>.</p><p>More exciting hardware projects from Skycoin, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet Hardware Development Kit is available to order online at <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning October 14, 2019.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Drew MacGibbon</strong> <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a> <br>+15624529482</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_10_18: {
      title: 'Secure and Private “New Internet” Skywire set to Launch in New York City',
      description: 'First Skywire NYC Meetup is a success',
      dates: 'October 18, 2019',
      content: {
        description: '<p><em>First Skywire NYC Meetup is a success</em></p><p><strong>New York City, New York / October 14th, 2019 /</strong> Skycoin held its first Skywire Mainnet Meetup in New York City on Thursday in anticipation of its forthcoming Skywire mesh network. The meeting took place at the NYC Blockchain Center, where Skycoin is a member, and was a great success. The meeting was also live-streamed via YouTube where dozens more watched it live, and several hundred tuned in to watch the final recording.</p><p>Skywire is the Skycoin Project’s new decentralized, private, and end-to-end encrypted internet. It is a mesh network comprised of small antennas attached to nodes called Skyminers. (Skyminers are powerful computers that provide the processing power, storage, and bandwidth for the network.)</p><p>The Skywire network in New York City is being built by members of the Skycoin community who believe in the principles of a free and open Internet, where privacy and security are foundational. Skywire puts the power is firmly in the hands of users, rather than Internet Service Providers, corporations, or advertisers. And unlike other attempts at creating community mesh nets, Skywire is incentivized. This means that Skycoin will pay node operators for their service to the network as a way to encourage growth and adoption of Skywire.</p><p>The ongoing rollout of the New York meshnet across Manhattan is a major milestone and proof-of-concept for the Skycoin Project, which has been working on the “new Internet” for nearly a decade.</p><p>Presenters at the meetup explained the technical details of the Skywire network to attendees, including multi-label packet switching (MPLS), public-key addressing, and software-defined networking, all of which make the Skywire network faster, safer, and more private than the current Internet. A number of antennas were shown as well, including long and short-range antennas. It is these antennas that will allow Skywire nodes to connect to one another across the city, and allow anyone within range to freely join the network.</p><p>The Skywire network will continue to be built over the coming months, growing stronger as more New Yorkers join the effort by deploying Skywire nodes of their own. The nodes themselves are easy to build using readily available parts, or may be purchased directly from skycoin.com.</p><p>Anyone interested in helping out should connect with the New York team via Telegram at t.me/SkycoinNewYork.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Khalob Freeborn</strong> <br><a href="mailto:khalob@skycoin.comm">khalob@skycoin.com</a> <br>+14243542994</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_11_26: {
      title: 'Skycoin Project Releases Affordable High-Security Hardware Wallet',
      description: 'Skycoin is the first cryptocurrency to issue its own hardware wallet.',
      dates: 'November 26, 2019',
      content: {
        description: '<p><em>Skycoin is the first cryptocurrency to issue its own hardware wallet.</em></p><p><em>Shanghai, China</em> — Skycoin is pleased to announce the immediate availability of <strong><em>Skywallet</em></strong>, a sleek and sophisticated cryptocurrency hardware wallet designed specifically with Skycoin in mind.</p><p>Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold many different coins and tokens, including Bitcoin, Ethereum, and more. In addition, a Hardware Development Kit (HDK) is available to developers who wish to further extend the Skywallet’s functionality.</p><p>Skywallet is initially available in three different colors (black, white, and silver) for just $39.00 USD each. Despite the massive price drop relative to competition, no corners have been cut on ensuring that these devices are secure. In fact, the Skycoin team uncovered and resolved significant flaws in the firmware code of one of the most popular devices currently available.</p><p>“We wanted everyone to have an affordable option for securely protecting their Skycoin investment,” said a spokesperson for the project.</p><p>Unlike mobile or desktop software wallets, the seed phrase (or “private key”) that generates the Skycoin address on the Skywallet is never exposed to a computer or the Internet, and cannot be accessed or hijacked by an attacker.<strong>This means the Skywallet is completely private and secure</strong>, even if one’s personal computer or Internet connection is compromised.</p><p>The security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">GitHub</a>.</p><p>The Skycoin team is uniquely qualified to produce Skywallets, as they have nearly a decade of experience building both hardware and software solutions to some of blockchain’s most intractable problems. Skycoin’s existing hardware products include approximately 10,000 Skyminer nodes deployed around the world, forming the telecommunications infrastructure of Skycoin’s new encrypted internet: Skywire.</p><p>More exciting hardware projects, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet is available to order online at &nbsp; <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning November 28, 2019.</p><p>Media who wish to schedule interviews may reach out to:&nbsp;</p><p>Tiffany</p><p> <a href="mailto:mktcn@skycoin.com">mktcn@skycoin.com</a></p><p>0085263533831</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
  },
  sky_wallet: {
    title: 'Skywallet - Skycoin`s New Hardware Wallet',
    description: 'Skywallet - New Hardware Wallet',
    about: {
      heading: 'Skywallet',
      subheading: 'Skycoin`s New Hardware Wallet',
      paragraph: 'When you store or access your cryptocurrency, you are your own bank, so the process should be simple and intuitive. Your hardware wallet is your bank vault and it should feel like a premium and secure device. We’ve spent months iterating over designs and incorporating user feedback in order to make Skywallet the best hardware wallet experience on the market.',
    },
    features: {
      heading: 'Getting started',
      recoveryseed: {
        title: 'Recovery seed',
        text:
          'The recovery seed is a backup for your entire device. If your device is lost or damaged, you can recover your wallets using the seed phrase. It is generated on your device and only shown once. It should go without saying that if somebody finds your seed, they can easily clone your device. Do not store the seed or communicate it digitally. Support will never ask for your seed.',
      },
      instructions: {
        title: 'Instructions',
        text:
          'Before connecting to your computer, please ensure that you have the latest version of the skycoin desktop wallet installed available at skycoin.com/downloads. If it is already installed, simply plug your device into your computer and follow the instructions on screen.',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<p>Download the Skywallet user manual here:</p><p> <a href="https://s3-ap-southeast-1.amazonaws.com/downloads.skycoin.com/skywallet/Skywallet-User_Manuals_Draft_1_c.pdf" rel="noopener noreferrer" target="_blank">User Manual</a></p><p>Download the Desktop Wallet and the Skywallet Daemon here:</p><p> <a href="/zh/downloads/">https://skycoin.com/downloads/</a></p>',
      },
    },
    roadmap: 'CX Roadmap',
  },
  skywallethdk: {
    title: 'Skywallet HDK',
    description: 'Skywallet HDK - Make your favourite token compatible with Skywallet',
    about: {
      heading: 'Skywallet HDK',
      subheading: 'Make your favourite token compatible with Skywallet',
      paragraph: '<p>The Skywallet HDK (Hardware Development Kit) is the developer-friendly version of the Skywallet hardware that is intended to make it easy to create applications, or integrate other cryptocurrencies and tokens into the Skywallet.</p><p>There are several key differences between the Skywallet and the Skywallet HDK that make the HDK easier to use for developers. The Skywallet HDK:</p><ul> <li>Does not have a case around the circuit board</li><li>Is physically bigger than the small, sleek consumer-facing Skywallet</li><li>Features larger buttons that are easier to work with</li><li>Has a 6-pin socket for ST programmer</li><li>Does not have a pre-flashed bootloader</li></ul><p>The primary use of the Skywallet HDK is to build capability into Skywallet to support cryptocurrencies beyond Skycoin and Skycoin Coin Hours. The HDK may also be used to create additional programs that may run on Skywallet. If a developer wishes to use Skywallet as an authentication device, for instance, they can use the HDK to develop that functionality.</p><p>All new programs and token compatibilities which are developed on the Skywallet HDK can be submitted to Skycoin for review. If approved, your update will be pushed out to all current Skywallet holders who can opt-in to the new functionality.</p><p>If you would like to extend the functionality and capability of Skywallet for all its users, grab a Skywallet HDK and get coding!</p>',
    },
    features: {
      heading: 'Getting started',
      instructions: {
        title: 'Instructions',
        text: '<p>Join the Telegram room <a href="https://t.me/SkycoinDevelopers" rel="noopener noreferrer" target="_blank">&commat;SkycoinDevelopers</a> or file an issue on Github if you want to get in touch with the development team.</p>',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/hardware-wallet" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
      documentation: {
        title: 'Documentation and codebase',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/User-Manuals/tree/master/Skywallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/User-Manuals/tree/master/Skywallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
    },
    gallery: {
      title: 'Gallery',
      description: 'Gallery',
      heading: 'Gallery',
      skywallethdk: {
        heading: 'Gallery',
      },
    },
  },
  cxchains: {
    title: 'CX Chains Overview',
  },
};



// WEBPACK FOOTER //
// ./src/locales/zh.js